/* eslint-disable */

/** unique or primary key constraints on table "argo.event_type" */
export enum ArgoEventTypeConstraint {
  /** unique or primary key constraint on columns "name_unique" */
  EventTypeNameUnique = 'event_type_name_unique',
  /** unique or primary key constraint on columns "event_type_id" */
  EventTypePkey = 'event_type_pkey'
}

/** select columns of table "argo.event_type" */
export enum ArgoEventTypeSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  IsNonProductive = 'is_non_productive',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Priority = 'priority'
}

/** update columns of table "argo.event_type" */
export enum ArgoEventTypeUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  IsNonProductive = 'is_non_productive',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Priority = 'priority'
}

